module.exports = __webpack_public_path__ + "static/BG_Maps-46ba2107b492a44c1ee34a8e41982a0e.jpg";